/* #region header */
/**************************************************************************************************
//
//  Description: Police Risk Categories
//
//  Copyright:    © 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   13.04.21 Sean Flook         WI39345 Initial Revision.
//    002   12.05.21 Sean Flook         WI39345 Added avatar_icon property.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
/* #endregion header */

const RiskCategoryPolice = [
  {
    id: 1,
    category: "People",
    avatar_id: 1,
    avatar_text: "P",
    avatar_icon: "/images/categories/People.svg",
  },
  {
    id: 2,
    category: "Animals",
    avatar_id: 2,
    avatar_text: "A",
    avatar_icon: "/images/categories/Animals.svg",
  },
  {
    id: 3,
    category: "Weapons",
    avatar_id: 3,
    avatar_text: "W",
    avatar_icon: "/images/categories/Weapons.svg",
  },
  {
    id: 4,
    category: "Miscellaneous",
    avatar_id: 4,
    avatar_text: "M",
    avatar_icon: "/images/categories/MiscellaneousRisk.svg",
  },
];

export default RiskCategoryPolice;
